<template>
  <input
    id="date"
    class="mt-select-date"
    type="date">
</template>

<script>
export default {
  name: 'MtSelectDate'
}
</script>

<style lang="scss" scoped>

  .mt-select-date{
    -webkit-appearance: none;
    padding-left: 10px;
    width: 100%;
    height: 40px;
    border: none !important;
    border-radius: 2px !important;
    background-color: white;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-select-date.vue